<template>
  <div
    class="w-100"
    style="
      border: 1px solid #cccccc;
      border-radius: 8px;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
    "
  >
    <div class="p-3">
      <div class="input-group mb-3">
        <input
          dir="rtl"
          type="text"
          class="form-control small"
          placeholder=""
          aria-describedby="button-addon2"
        />
        <button class="btn btn-sm btn-outline-secondary" type="button" id="button-addon2">
          جستجو
        </button>
      </div>
      <div class="d-flex flex-row bd-highlight mt-4" style="font-size: 14px">
        <div class="bd-highlight">
          <div class="ms-auto bd-highlight">
            <nav aria-label="Chart note navigation">
              <ul class="pagination pagination-sm justify-content-center">
                <li class="page-item">
                  <select class="page-link" type="button">
                    <option>تاریخ</option>
                    <option>عنوان</option>
                  </select>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="me-auto" style="line-height: 30px; margin-left: 10px">مرتب‌سازی</div>

        <div class="ms-auto bd-highlight">
          <nav aria-label="Chart note navigation">
            <ul class="pagination pagination-sm justify-content-center">
              <li class="page-item">
                <select class="page-link" type="button">
                  <option selected>تعداد نمایش</option>
                  <option>5</option>
                  <option>10</option>
                  <option>20</option>
                </select>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ol class="list-group list-group-flush p-0" dir="rtl">
        <li class="list-group-item d-flex justify-content-between align-items-start">
          <div class="ms-auto me-2">
            <div class="fw-bold">این عنوان تست است</div>
            1402/11/1
          </div>
          <span class="badge bg-primary rounded-pill">14</span>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-start">
          <div class="ms-auto me-2">
            <div class="fw-bold">این عنوان تست است</div>
            1402/11/1
          </div>
          <span class="badge bg-primary rounded-pill">14</span>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-start">
          <div class="ms-auto me-2">
            <div class="fw-bold">این عنوان تست است</div>
            1302/11/22
          </div>
          <span class="badge bg-primary rounded-pill">14</span>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-start">
          <div class="ms-auto me-2">
            <div class="fw-bold">این عنوان تست است</div>
            1302/11/22
          </div>
          <span class="badge bg-primary rounded-pill">14</span>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-start">
          <div class="ms-auto me-2">
            <div class="fw-bold">این عنوان تست است</div>
            1302/11/22
          </div>
          <span class="badge bg-primary rounded-pill">14</span>
        </li>
      </ol>
      <div class="d-flex flex-row bd-highlight mt-3">
        <div class="bd-highlight">
          <div class="ms-auto bd-highlight">
            <nav aria-label="Chart note navigation">
              <ul class="pagination pagination-sm justify-content-center">
                <li class="page-item">
                  <select class="page-link" type="button">
                    <option>5</option>
                    <option>10</option>
                    <option>20</option>
                  </select>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="ms-auto bd-highlight">
          <nav aria-label="Chart note navigation">
            <ul class="pagination pagination-sm justify-content-center">
              <li class="page-item disabled">
                <a class="page-link" href="#" tabindex="-1" aria-disabled="true">قبلی</a>
              </li>
              <li class="page-item"><a class="page-link" href="#">1</a></li>
              <li class="page-item"><a class="page-link" href="#">2</a></li>
              <li class="page-item"><a class="page-link" href="#">3</a></li>
              <li class="page-item">
                <a class="page-link" href="#">بعدی</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "NoteListPro",
  components: {
  },
  data() {
    return {
      editor: [],
      editorData: "",
      editorConfig: {
        toolbar: ["bold", "italic", "|", "link"],
        language: {
          ui: "en",
          content: "ar",
        },
      },
    };
  },
};
</script>

<style>
.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
<style scoped>
.note-title {
  font-size: 14px;
}
</style>
